module.exports = __webpack_public_path__ + "static/media/glass.c51ca838.png";